import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const Pointer = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="Pointer"
    {...props}
  >
    <g id="Pointer">
      <path
        id="Vector 1"
        d="M1 7.00051L9 11L17 7.00051V1H1V7.00051Z"
        fill="#1F77B4"
        stroke="#1F77B4"
      />
    </g>
  </svg>
);
export default React.memo(Pointer);
